export default "__VITE_ASSET__CzrRfqMF__"